/*
 * Whiteflys — Hero carousel
 * Vanilla, sem dependências. Crossfade suave, autoplay com pause on hover/focus,
 * setas, indicadores, teclado e respeito a prefers-reduced-motion.
 */
class WhiteflysCarousel {
  constructor(root) {
    this.root = root;
    this.slides = Array.from(root.querySelectorAll('[data-wf-slide]'));
    this.dots = Array.from(root.querySelectorAll('[data-wf-dot]'));
    this.prevBtn = root.querySelector('[data-wf-prev]');
    this.nextBtn = root.querySelector('[data-wf-next]');
    this.toggleBtn = root.querySelector('[data-wf-toggle]');

    this.interval = parseInt(root.dataset.interval, 10) || 6000;
    this.autoplay = root.dataset.autoplay === 'true';
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.index = 0;
    this.timer = null;
    this.userPaused = false;

    if (this.slides.length <= 1) this.autoplay = false;

    this.bind();
    this.goTo(0);
    if (this.autoplay && !this.reduce) this.start();
  }

  bind() {
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
    this.dots.forEach((dot, i) =>
      dot.addEventListener('click', () => {
        this.goTo(i);
        this.restart();
      })
    );
    if (this.toggleBtn) this.toggleBtn.addEventListener('click', () => this.toggle());

    // Pausas transitórias (não sobrescrevem a pausa explícita do usuário)
    this.root.addEventListener('mouseenter', () => this.pause());
    this.root.addEventListener('mouseleave', () => this.resume());
    this.root.addEventListener('focusin', () => this.pause());
    this.root.addEventListener('focusout', () => this.resume());
    document.addEventListener('visibilitychange', () =>
      document.hidden ? this.pause() : this.resume()
    );

    // Navegação por teclado quando o foco está no carrossel
    this.root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.step(1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.step(-1);
      }
    });
  }

  step(dir) {
    this.goTo(this.index + dir);
    this.restart();
  }

  goTo(i) {
    const n = this.slides.length;
    this.index = ((i % n) + n) % n;

    this.slides.forEach((slide, idx) => {
      const active = idx === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      // Só o slide ativo é focável/clicável. A camada de toque que cobre o
      // slide (data-wf-stretched) nunca entra na ordem de tabulação: ela
      // duplicaria o link do botão para quem navega pelo teclado.
      slide.querySelectorAll('a:not([data-wf-stretched])').forEach((a) => {
        a.tabIndex = active ? 0 : -1;
      });
    });

    this.dots.forEach((dot, idx) => {
      const active = idx === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
    this.setToggleState(true);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restart() {
    if (this.autoplay && !this.reduce && !this.userPaused) this.start();
  }

  pause() {
    this.stop();
  }

  resume() {
    if (this.autoplay && !this.reduce && !this.userPaused) this.start();
  }

  toggle() {
    this.userPaused = !this.userPaused;
    if (this.userPaused) {
      this.stop();
      this.setToggleState(false);
    } else {
      this.start();
    }
  }

  setToggleState(playing) {
    if (!this.toggleBtn) return;
    this.toggleBtn.dataset.state = playing ? 'playing' : 'paused';
    const label = playing ? this.toggleBtn.dataset.labelPause : this.toggleBtn.dataset.labelPlay;
    if (label) this.toggleBtn.setAttribute('aria-label', label);
  }
}

function initWhiteflysCarousels() {
  document
    .querySelectorAll('[data-wf-carousel]')
    .forEach((el) => new WhiteflysCarousel(el));
}

if (document.readyState !== 'loading') {
  initWhiteflysCarousels();
} else {
  document.addEventListener('DOMContentLoaded', initWhiteflysCarousels);
}
